import { InjectionToken } from "@angular/core";

export interface DeloitteAiEnvironment {
    [key: string]: string | number | boolean | DeloitteAiEnvironment;

    context: "store" | "asset_owner_portal" | "landing";

    brain_base_url: string;
}

export const DELOITTEAI_ENVIRONMENT = new InjectionToken<DeloitteAiEnvironment>("DeloitteAi Environment");
